import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ResetPassComponent } from './auth/reset-pass/reset-pass.component';
import { VerifyUserComponent } from './auth/verify-user/verify-user.component';
import { LogoutComponent } from './auth/logout/logout.component';

const routes: Routes = [
	{ path: 'login', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
	{ path: 'forgot/password/:email', component: ResetPassComponent },
	// { path: 'verify/user/:token', component: VerifyUserComponent },
	{ path: 'logout', component: LogoutComponent },
	{ path: '', redirectTo: 'index', pathMatch: 'full' }
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})

export class AppRoutingModule { }